import { render, staticRenderFns } from "./videoonlinecourse.vue?vue&type=template&id=9f80ecde&scoped=true&"
import script from "./videoonlinecourse.vue?vue&type=script&lang=js&"
export * from "./videoonlinecourse.vue?vue&type=script&lang=js&"
import style0 from "./videoonlinecourse.vue?vue&type=style&index=0&id=9f80ecde&scoped=true&lang=scss&"
import style1 from "./videoonlinecourse.vue?vue&type=style&index=1&id=9f80ecde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f80ecde",
  null
  
)

export default component.exports